<div class="auth-spinner-container">
    <mat-spinner class="center"></mat-spinner>
    <h1>{{'@authLoggingOut' | translate}}</h1>
</div>